// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorModel {
    static getAttributeTypeMap() {
        return PayorModel.attributeTypeMap;
    }
}
PayorModel.discriminator = undefined;
PayorModel.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PayorSharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PayorSharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PayorSharedEmailAddressModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PayorSharedWebAddressModel>"
    },
    {
        "name": "coverageAreas",
        "baseName": "coverageAreas",
        "type": "Array<PayorCoverageAreaModel>"
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<PayorSharedGlobalIdModel>"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "payorType",
        "baseName": "payorType",
        "type": "PayorType"
    },
    {
        "name": "payorBin",
        "baseName": "payorBin",
        "type": "string"
    },
    {
        "name": "payorPcn",
        "baseName": "payorPcn",
        "type": "string"
    },
    {
        "name": "payorGroup",
        "baseName": "payorGroup",
        "type": "string"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    }
];
//# sourceMappingURL=payorModel.js.map